<script>
export default {
    props: {
        supplier: {
            type: String,
            required: true
        },
        contractId: {
            type: Number,
            required: true
        },
        supplierId: {
            type: Number,
            required: true,
        },
        status: {
            type: String,
            required: true
        },
        lastUpdated: {
            type: String,
            default: ''
        },
        updatedBy: {
            type: String,
            default: ''
        },
        url: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            toggled: false
        }
    }
}
</script>
<template>
    <div class="contract-management-item">
        <div class="contract-management-item__header">
            <div class="contract-management-item__label">
                {{ supplier }}
            </div>
            <div class="contract-management-item__control" @click="toggled = !toggled">
                <i class="fa fa-fw fa-info"/>
            </div>
        </div>
        <div v-if="toggled" class="contract-management-item__content">
            <div class="contract-management-item__props">
                <div class="contract-management-item__prop">
                    <div class="contract-management-item__prop-key">
                        {{ $t('contractManagement.list.status.label') }}
                    </div>
                    <div class="contract-management-item__prop-value">
                        {{ $t('contractManagement.list.status.' + status) }}
                    </div>
                </div>
                <div class="contract-management-item__prop">
                    <div class="contract-management-item__prop-key">
                        {{ $t('contractManagement.list.lastUpdated') }}
                    </div>
                    <div class="contract-management-item__prop-value">
                        {{ lastUpdated | moment("DD/MM/YYYY") }}
                    </div>
                </div>
                <div class="contract-management-item__prop">
                    <div class="contract-management-item__prop-key">
                        {{ $t('contractManagement.list.updatedBy') }}
                    </div>
                    <div class="contract-management-item__prop-value">
                        {{ updatedBy }}
                    </div>
                </div>
                <div class="contract-management-item__prop">
                    <router-link :to="{name: 'contractManagement', params: {contractId: contractId}}"
                                 class="contract-management-item__prop-button">
                        <span v-if="!url"><i class="fa fa-edit"/> {{ $t('contractManagement.list.edit') }}</span>
                        <span v-if="url"><i class="fa fa-download"/> {{ $t('contractManagement.list.download') }}</span>
                    </router-link>

                </div>
                <div v-if="status === 'readyForContractManager' || status === 'readyForSupplier'" class="contract-management-item__prop">
                    <router-link :to="{name: 'contract', params: {contractId: contractId, supplierId: supplierId}}"
                                 class="contract-management-item__prop-button">
                        <span v-if="!url"><i class="fa fa-eye"/> {{ $t('contractManagement.list.view') }}</span>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractManagementItem/ContractManagementItem.vue